export default __webpack_public_path__ + "static/media/bengals_white.c491600c.png";